import { Injectable } from '@angular/core';

import { manutencoesRoute } from "../../shared/data.service";
import { manutencoesProgramadaRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { ordensServicoRoute } from "../../ordens-servico/shared/data.service";
import { newRoute } from "../../../shared/services/data.service";
import {servicosRoute} from "../../servicos/shared/data.service";

@Injectable()
export class ManutencaoProgramadaNavigationService {

    constructor(
        private _authService: AuthService
    ) {}

    goToList() {
        let router: string = manutencoesRoute + '/' + manutencoesProgramadaRoute;
        this._authService.navigateTo(router);
    }

    goToNewOS() {
        let router: string = manutencoesRoute + '/' + manutencoesProgramadaRoute + '/' + ordensServicoRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToServico(benServicoId: number) {
        let router: string = manutencoesRoute + '/' + manutencoesProgramadaRoute + '/' + servicosRoute;
        this._authService.navigateTo(router, benServicoId);
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/shared/manutencao-programada-navigation.service.ts
 **/